import RequiredDocumentsList from "./RequiredDocumentsList";

export default RequiredDocumentsList;
